<template>
  <div class="form-project">
    <avue-form :option="tableOption" ref="form" v-model="form" @submit="submit">
      <template slot="listSoilType">
        <div style="display: flex">
          <el-select
            v-model="form.listSoilType"
            multiple
            clearable
            placeholder="请选择 土质"
          >
            <el-option
              v-for="(item, i) in soilTypes"
              :key="i"
              :label="item.itemName"
              :value="item.itemName"
            >
            </el-option>
          </el-select>
          <el-button
            plain
            type="primary"
            style="margin-right: -120px; margin-left: 20px; height: 32px"
            @click="checkAllSoil"
            >{{
              form.listSoilType.length == soilTypes.length &&
              form.listSoilType.length > 0
                ? "取消全选"
                : "选中全部"
            }}</el-button
          >
        </div>
      </template>
      <template slot="memberIds" slot-scope="scope">
        <div style="position: relative">
          <div
            style="
              border: 1px solid #d9d9d9;
              border-radius: 4px;
              line-height: 30px;
              min-height: 32px;
              cursor: pointer;
            "
          >
            <span
              style="color: #b4bccc; padding-left: 15px"
              v-if="userList.length == 0"
            >
              请选择项目成员
            </span>
            <span v-else>
              <el-tag
                closable
                v-for="(item, index) in userList"
                size="mini"
                type="info"
                @close="preventDefault(item, index)"
                :key="item.id"
                style="margin-left: 4px"
              >
                {{ item.deptName }}
              </el-tag>
            </span>
            <el-button
              size="small"
              type="text"
              style="
                position: absolute;
                right: 10px;
                top: 10px;
                cursor: pointer;
              "
              @click.stop="visible3 = true"
              >选择</el-button
            >
          </div>
        </div>
      </template>
      <!-- 详细地址: 支持手动输入, 仅点击地图按钮打开地图选点 -->
      <template slot="projectAddress">
        <div class="project-address-with-map">
          <el-input
            v-model="form.projectAddress"
            placeholder="请输入详细地址"
            maxlength="30"
            show-word-limit
            clearable
            class="address-input-manual"
          />
          <img
            src="@/static/project/map.png"
            alt=""
            class="map-icon map-icon-after-address"
            @click="openMap"
          />
        </div>
      </template>
      <template slot="electronicRange">
        <el-input
          v-model="form.electronicRange"
          @input="handleElectronicRange"
          placeholder="请输入范围（米）"
        ></el-input>
      </template>
      <template slot="fleetNameModelType">
        <el-checkbox-group v-model="fleetNameModelTypeCheck">
          <el-checkbox label="1">可输入</el-checkbox>
          <el-checkbox label="2">可选择</el-checkbox>
        </el-checkbox-group>
      </template>
      <template slot="truckCodePeriod">
        <el-input
          v-model="form.truckCodePeriod"
          type="number"
          placeholder="请输入"
          class="custom-input"
        >
          <template #append>
            <span style="color: #888">天内</span>
          </template>
        </el-input>
      </template>
      <template slot="goInterval">
        <el-input
          v-model="form.goInterval"
          type="number"
          placeholder="请输入"
          class="custom-input"
        >
          <template #append>
            <span style="color: #888">分钟</span>
          </template>
        </el-input>
      </template>
      <template slot="inWaybillSaveTime">
        <el-input
          v-model="form.inWaybillSaveTime"
          type="number"
          placeholder="请输入"
          class="custom-input"
        >
          <template #append>
            <span style="color: #888">分钟</span>
          </template>
        </el-input>
      </template>

      <template slot="goWaybillTipCheck">
        <el-checkbox
          :checked="form.goWaybillTipCheck == 1"
          v-model="form.goWaybillTipCheck"
          true-label="1"
          false-label="0"
          >需要</el-checkbox
        >
      </template>
      <template slot="isInPictureUploadOffline">
        <el-checkbox
          :checked="form.isInPictureUploadOffline == 1"
          v-model="form.isInPictureUploadOffline"
          true-label="1"
          false-label="0"
          >需要</el-checkbox
        >
      </template>
      <template slot="isGoPictureUploadOffline">
        <el-checkbox
          :checked="form.isGoPictureUploadOffline == 1"
          v-model="form.isGoPictureUploadOffline"
          true-label="1"
          false-label="0"
          >需要</el-checkbox
        >
      </template>
      <template slot="overtimePeriod">
       
        <el-checkbox
          v-model="form.overtimePeriod"
          :checked="form.overtimePeriod == 999999"
          :true-label="999999"
          :false-label="dynamicValue"
          @change="changePeriod"
          >不需要</el-checkbox
        >
         <el-checkbox
          v-model="form.overtimePeriod"
          :checked="dynamicValue == form.overtimePeriod"
          :true-label="dynamicValue"
          :false-label="999999"
          @change="changePeriod"
          >需要</el-checkbox
        >
        <el-input
          v-model="dynamicValue"
          v-if="form.overtimePeriod!=999999"
          type="number"
          @input="checkMax"
          placeholder="请输入值"
          size="small"
          style="width: 180px; margin-left: 10px"
          class="custom-input"
        >
          <template #append>
            <span style="color: #888">小时内</span>
          </template>
        </el-input>
      </template>
      <template slot="isTicket" slot-scope="scope">
        <el-checkbox
          :checked="form.ticketEnable == 1"
          v-model="form.ticketEnable"
          true-label="1"
          false-label="0"
          >工地清点票数</el-checkbox
        >
        <el-checkbox
          :checked="form.isTicketInventory == 1"
          v-model="form.isTicketInventory"
          @change="changeBox"
          true-label="1"
          false-label="0"
          >泥尾票库存管理</el-checkbox
        >
        <div
          v-if="form.isTicketInventory == 1"
          style="margin-left: 136px; margin-top: 6px"
        >
          <el-switch
            active-value="1"
            inactive-value="0"
            active-text="出场签单是否对票号精细化管理"
            v-model="form.manualSelectTicket"
          >
          </el-switch>
        </div>
      </template>
      <template slot="isEntranceWaybill" slot-scope="scope">
        <el-checkbox
          :checked="
            form.isEntranceHeavyWaybill == 1 || form.isEntranceWaybill == 1
          "
          v-model="isEntranceWaybill"
          @change="changeIsEntranceWaybill"
          >需要</el-checkbox
        >
        <div
          class="block"
          v-if="
            isEntranceWaybill ||
            form.isEntranceHeavyWaybill == 1 ||
            form.isEntranceWaybill == 1
          "
        >
          <div>
            <el-checkbox
              :checked="form.isEntranceWaybill == 1"
              v-model="form.isEntranceWaybill"
              true-label="1"
              false-label="0"
              >空车</el-checkbox
            >
            <el-checkbox :checked="true" disabled>承运车辆</el-checkbox>
            <el-checkbox :checked="true" disabled>签单备注</el-checkbox>
            <el-checkbox :checked="true" disabled>拍照凭证</el-checkbox>
          </div>
          <div>
            <el-checkbox
              :checked="form.isEntranceHeavyWaybill == 1"
              v-model="form.isEntranceHeavyWaybill"
              true-label="1"
              false-label="0"
              >重车</el-checkbox
            >
            <el-checkbox :checked="true" disabled>承运车辆</el-checkbox>
            <el-checkbox :checked="true" disabled>签单备注</el-checkbox>
            <el-checkbox :checked="true" disabled>拍照凭证</el-checkbox>
            <el-checkbox :checked="true" disabled>土质</el-checkbox>
          </div>
        </div>
      </template>
      <template slot="annotationForm" slot-scope="scope">
        <ul
          style="
            background: #f4f3f3;
            line-height: 20px;
            padding: 8px 15px;
            font-size: 12px;
            color: red;
          "
        >
          <li>此模式是司机使用电子卡签单及APP直付，存在两种情况：</li>
          <li>
            某个司机设置直付价，司机使用APP出车、出场、卸土、收车操作后付款到司机APP钱包；
          </li>
          <li>某个司机未设置直付价，使用电子卡结算。</li>
        </ul>
      </template>
      <!-- <template slot="smsNoticeMobile" slot-scope="scope">
          <el-form
            label-width="180px"
            :model="mobileForm"
            ref="mobileForm"
            :inline="true"
          >
            <div
              v-for="(item, index) in mobileForm.smsNoticeMobile"
              :key="index"
            >
              <el-form-item
                style="margin-bottom: 0px"
                :style="index != 0 ? 'padding-left:136px' : ''"
                :label="index == 0 ? 'APP支付手机号码:' : ''"
                :prop="'smsNoticeMobile.' + index + '.mobile'"
                label-width="'128px'"
                :rules="[
                  { required: true, message: '请输入', trigger: 'blur' },
                  {
                    validator: isMobileNumber,
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="item.mobile"
                  :style="index != 0 ? 'margin-top: 14px' : ''"
                  maxlength="11"
                  size="small"
                  placeholder="请输入手机号码"
                ></el-input>
              </el-form-item>
              <el-button
                style="margin-left: 8px; margin-top: 3px"
                type="primary"
                size="small"
                icon="el-icon-plus"
                @click="add"
                v-if="index == 0"
                >添加</el-button
              >
              <el-button
                style="margin-left: 8px; margin-top: 15px"
                type="primary"
                size="small"
                icon="el-icon-plus"
                @click="del(item, index)"
                v-else
                >删除</el-button
              >
            </div>
          </el-form>
        </template> -->
      <template slot="isIn" slot-scope="scope">
        <el-checkbox
          :checked="form.isIn == 1"
          v-model="form.isIn"
          @change="changeIsEntranceWaybill"
          true-label="1"
          false-label="0"
          >需要</el-checkbox
        >
        <div class="block" v-if="form.isIn == 1">
          <div>
            <el-checkbox :checked="true" disabled>外运</el-checkbox>
            <el-checkbox
              :checked="form.isInSoilType == 1"
              v-model="form.isInSoilType"
              @change="changeValue($event, 'isInSoilType')"
              true-label="1"
              false-label="0"
              >土质</el-checkbox
            >
            <el-checkbox
              :checked="form.isInPic == 1"
              v-model="form.isInPic"
              @change="changeValue($event, 'isInPic')"
              true-label="1"
              false-label="0"
              >拍照凭证</el-checkbox
            >
            <el-checkbox
              :checked="form.weightType == 2"
              v-model="form.weightType"
              @change="changeValue($event, 'weightType')"
              true-label="2"
              false-label="1"
              >单位</el-checkbox
            >
            <el-checkbox
              :checked="form.weightType == 2"
              v-model="form.weightType"
              @change="changeValue($event, 'weightType')"
              true-label="2"
              false-label="1"
              >数量</el-checkbox
            >
            <el-checkbox :checked="true" disabled>承运车辆</el-checkbox>
          </div>
          <div>
            <el-checkbox :checked="true" disabled>内运</el-checkbox>
            <el-checkbox
              :checked="form.isInSoilType == 1"
              v-model="form.isInSoilType"
              @change="changeValue($event, 'isInSoilType')"
              true-label="1"
              false-label="0"
              >土质</el-checkbox
            >
            <el-checkbox
              :checked="form.isInPic == 1"
              v-model="form.isInPic"
              @change="changeValue($event, 'isInPic')"
              true-label="1"
              false-label="0"
              >拍照凭证</el-checkbox
            >
            <el-checkbox
              :checked="form.weightType == 2"
              v-model="form.weightType"
              @change="changeValue($event, 'weightType')"
              true-label="2"
              false-label="1"
              >单位</el-checkbox
            >
            <el-checkbox
              :checked="form.weightType == 2"
              v-model="form.weightType"
              @change="changeValue($event, 'weightType')"
              true-label="2"
              false-label="1"
              >数量</el-checkbox
            >
            <el-checkbox
              :checked="form.weightType == 2"
              v-model="form.weightType"
              @change="changeValue($event, 'weightType')"
              true-label="2"
              false-label="1"
              >单价</el-checkbox
            >
            <el-checkbox :checked="true" disabled>承运车辆</el-checkbox>

            <div>
              <el-checkbox :checked="true" disabled>内转回填</el-checkbox>
              <el-checkbox
                :checked="form.isInSoilType == 1"
                v-model="form.isInSoilType"
                @change="changeValue($event, 'isInSoilType')"
                true-label="1"
                false-label="0"
                >土质</el-checkbox
              >
              <el-checkbox
                :checked="form.isInPic == 1"
                v-model="form.isInPic"
                @change="changeValue($event, 'isInPic')"
                true-label="1"
                false-label="0"
                >拍照凭证</el-checkbox
              >
              <el-checkbox
                :checked="form.weightType == 2"
                v-model="form.weightType"
                @change="changeValue($event, 'weightType')"
                true-label="2"
                false-label="1"
                >单位</el-checkbox
              >
              <el-checkbox
                :checked="form.weightType == 2"
                v-model="form.weightType"
                @change="changeValue($event, 'weightType')"
                true-label="2"
                false-label="1"
                >数量</el-checkbox
              >
              <el-checkbox
                :checked="form.weightType == 2"
                v-model="form.weightType"
                @change="changeValue($event, 'weightType')"
                true-label="2"
                false-label="1"
                >单价</el-checkbox
              >
              <el-checkbox :checked="true" disabled>承运车辆</el-checkbox>
            </div>
          </div>
        </div>
      </template>
      <!-- <template slot="isIn" slot-scope="scope">
        <el-checkbox :checked="form.isIn == 1" v-model="form.isIn" @change="changeIsIn" true-label="1"
          false-label="0">需要签单</el-checkbox>
        <el-checkbox :checked="form.weightType == 2" v-model="form.weightType"
          @change="changeValue($event, 'weightType')" true-label="2" false-label="1">挖机称重</el-checkbox>
        <el-checkbox :checked="form.isInSoilType == 1" v-model="form.isInSoilType"
          @change="changeValue($event, 'isInSoilType')" true-label="1" false-label="0">挖机土质</el-checkbox>
        <el-checkbox :checked="form.isInPic == 1" v-model="form.isInPic" @change="changeValue($event, 'isInPic')"
          true-label="1" false-label="0">挖机拍照</el-checkbox>
      </template> -->
      <template slot="manHourType" slot-scope="scope">
        <div>
          <el-tag
            :key="index"
            v-for="(tag, index) in dynamicTags"
            closable
            :disable-transitions="false"
            style="margin-right: 4px"
            @close="handleClose('dynamicTags', tag)"
          >
            {{ tag }}
          </el-tag>
          <!-- <div> -->
          <!-- <el-input class="input-new-tag" v-model="tagName" ref="saveTagInput" size="small"
              style="width: 200px; margin-left: 0; ">
            </el-input> -->
          <el-button
            slot="suffix"
            @click="addTag('dynamicTags', 'tagName', '作业类型')"
            type="primary"
            plain
            class="add-tag"
            >添加</el-button
          >
          <!-- </div> -->
        </div>
      </template>
      <template slot="inJobAddress" slot-scope="scope">
        <div>
          <el-tag
            :key="index"
            v-for="(tag, index) in inJobAddressTags"
            closable
            :disable-transitions="false"
            style="margin-right: 4px"
            @close="handleClose('inJobAddressTags', tag)"
          >
            {{ tag }}
          </el-tag>
          <!-- <div> -->
          <el-button
            slot="suffix"
            @click="addTag('inJobAddressTags', 'inJobAddressName', '作业地点')"
            type="primary"
            plain
            class="add-tag"
            >添加</el-button
          >
          <!-- </div> -->
        </div>
      </template>
      <template slot="inUnitWork" slot-scope="scope">
        <div>
          <el-tag
            :key="index"
            v-for="(tag, index) in inUnitWorkTags"
            closable
            :disable-transitions="false"
            style="margin-right: 4px"
            @close="handleClose('inUnitWorkTags', tag)"
          >
            {{ tag }}
          </el-tag>
          <!-- <div> -->
          <el-button
            slot="suffix"
            @click="addTag('inUnitWorkTags', 'inUnitWorkName', '工时单位')"
            type="primary"
            plain
            class="add-tag"
            >添加</el-button
          >
          <!-- </div> -->
        </div>
      </template>
      <!-- 班次设置 -->
      <template slot="projectShifts" slot-scope="scope">
        <div>
          <div style="display: flex; align-items: center">
            <!-- <label style="width: 114px; text-align: right">班次时间：</label> -->
            <el-input
              class="input-new-tag"
              v-model="shiftName"
              ref="saveTagInput"
              size="small"
              placeholder="班次名称"
              show-word-limit
              maxlength="10"
              style="width: 140px; margin-right: 8px;margin-left:0"
            >
            </el-input>
            <!-- <label>时间：</label> -->
            <div class="custom-time">
              <el-time-picker
                style="width: 150px !important; margin-right: 10px"
                v-model="shiftTimeStart"
                prefix-icon=" "
                value-format="HH:mm:ss"
                placeholder="开始日期"
              >
              </el-time-picker>
              <label>-</label>
              <el-time-picker
                prefix-icon=" "
                style="width: 150px !important; margin-right: 10px"
                v-model="shiftTimeEnd"
                value-format="HH:mm:ss"
                placeholder="结束日期"
              >
              </el-time-picker>
              <i
                class="el-icon-date"
                style="color: #939399; margin-right: 10px"
              ></i>
            </div>

            <el-button
              @click="addShifts"
              class="add-tag"
              type="primary"
              style="height: 32px"
              >确定添加</el-button
            >
          </div>
          <div
            style="display: flex; align-items: center"
            class="shift-tag-list"
          >
            <div
              class="shift-tag"
              v-for="(tag, index) in projectShiftsTags"
              :key="index"
            >
              <div class="left">
                {{ tag.shiftName }}
              </div>
              <div class="right">
                {{ tag.shiftTimeStart }}
                - {{ tag.shiftTimeEnd }}
              </div>
            </div>
            <!-- <el-tag
              :key="index"
              class="shift-tag"
              v-for="(tag, index) in projectShiftsTags"
              closable
              :disable-transitions="false"
              style="margin-right: 4px"
              @close="handleClose('projectShiftsTags', tag)"
            >
            </el-tag> -->
          </div>
        </div>
      </template>
      <template slot="isGo" slot-scope="scope">
        <el-checkbox :checked="true" disabled>需要</el-checkbox>
        <div>
          <el-checkbox
            :checked="form.isGoVehicleType == 1"
            v-model="form.isGoVehicleType"
            true-label="1"
            false-label="0"
            >车型</el-checkbox
          >
          <el-checkbox
            :checked="form.weightType == 3"
            v-model="form.weightType"
            true-label="3"
            false-label="1"
            >单位</el-checkbox
          >
          <el-checkbox
            :checked="form.weightType == 3"
            v-model="form.weightType"
            true-label="3"
            false-label="1"
            >数量</el-checkbox
          >
          <el-checkbox
            :checked="form.weightType == 3"
            v-model="form.weightType"
            true-label="3"
            false-label="1"
            >单价</el-checkbox
          >
          <el-checkbox
            :checked="form.isCubicPrice == 1"
            v-model="form.isCubicPrice"
            true-label="1"
            false-label="0"
            >价格</el-checkbox
          >
        </div>
        <div>
          <el-checkbox :checked="true" disabled>承运车辆</el-checkbox>
          <el-checkbox :checked="true" disabled>土质</el-checkbox>
          <el-checkbox :checked="true" disabled>拍照凭证</el-checkbox>
          <el-checkbox :checked="true" disabled>司机信息</el-checkbox>
          <el-checkbox :checked="true" disabled>今日出车数</el-checkbox>
          <el-checkbox :checked="true" disabled>挖机型号</el-checkbox>
          <el-checkbox :checked="true" disabled>挖机签单土质</el-checkbox>
          <el-checkbox :checked="true" disabled>车队长</el-checkbox>
          <el-checkbox :checked="true" disabled>车队名称</el-checkbox>
          <el-checkbox :checked="true" disabled>备注</el-checkbox>
        </div>
      </template>
      <template slot="electronicRangeLabel">
        <span style="line-height: 0">
          电子围栏(米):
        </span>
      </template>
    </avue-form>
    <el-dialog
      width="890px"
      title="选择地址"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div class="map">
        <div class="map-label">搜索地址：</div>
        <div class="map-right">
          <div>
            <el-amap-search-box
              class="search-box"
              :search-option="searchOption"
              :on-search-result="onSearchResult"
            >
            </el-amap-search-box>
          </div>
          <el-amap
            vid="amapDemo"
            :center="mapInfo.lnglat"
            :amap-manager="amapManager"
            :zoom="zoom"
            :events="events"
            class="amap-demo"
            style="height: 405px; width: 100%"
          >
            <el-amap-marker
              ref="marker"
              vid="component-marker"
              :draggable="true"
              :events="markerEvent"
              :position="mapInfo.lnglat"
            ></el-amap-marker>
            <el-amap-circle
              :center="mapInfo.lnglat"
              :radius="form.electronicRange"
              :fillOpacity="0.2"
              :events="events"
            ></el-amap-circle>
            <!-- fillColor="#ee2200"
              strokeColor="#ee2200"
              :strokeOpacity="0.35"
              :strokeWeight="0.35" -->
            <el-amap-text
              :text="projectAddressLabel.content"
              :position="mapInfo.lnglat"
              :offset="[0, -50]"
            ></el-amap-text>
          </el-amap>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button type="primary" size="small" @click="submitMap"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      width="480px"
      :close-on-click-modal="false"
      v-if="updateVisible"
      :show-close="false"
      :visible.sync="updateVisible"
    >
      <template slot="title">
        <div class="check-title1">
          <i class="el-icon-info" style="color: #35b1ff; margin-right: 8px"></i>
          <div>{{ updateOvertimePeriodTitle }}</div>
        </div>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeVisible">不在提醒</el-button>
        <el-button type="primary" @click="toCheck">立即前往</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="548px"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <template slot="title">
        <div class="check-title">
          <i class="el-icon-info" style="color: #35b1ff; margin-right: 8px"></i>
          {{ title }}
        </div>
      </template>
      <div class="desc">
        {{ desc }}
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="$emit('confirm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 选择人员框，后期调接口封装 -->
    <select-personnel
      v-if="visible3"
      :visible.sync="visible3"
      :list="userList"
      @changeUserList="changeUserList"
    ></select-personnel>
  </div>
</template>

<script>
import { tableOption } from "./addOrEditProject.js";
import { AMapManager } from "vue-amap";
const amapManager = new AMapManager();
import {
  putObj,
  listDictionaryItem,
  addObj,
  getMemberList,
} from "@/api/chain/projectinfo";
import selectPersonnel from "../components/selectPersonnel"; //选择人员
import {mapGetters} from 'vuex'
export default {
  props: ["info"],
  data() {
    return {
      soilTypes: [],
      memberList: [],
      visible3: false,
      userList: [],
      title: "",
      desc: "",
      dialogVisible: false,
      updateOvertimePeriodTitle: "",
      updateVisible: false,
      tmpOvertimePeriod: 0,
      fleetNameModelTypeCheck: [],
      tagErrTxt: "",
      tagObj: {
        tagsProp: "",
        label: "",
        prop: "tagName",
        errTxt: "",
      },
      tag: "",
      tagVisible: false,
      isGo: "1",
      isIn: "0",
      shiftTimeStart: null, //班次时间
      shiftTimeEnd: null, //班次时间
      inUnitWorkName: "",
      shiftName: "", //班次
      inJobAddressName: "",
      dynamicTags: [],
      inJobAddressTags: [],
      inUnitWorkTags: [],
      projectShiftsTags: [],
      tagName: null,
      previousChecked: 72,
      dynamicValue: 72,
      isEntranceWaybill: false,
      visible: false,
      tableOption: tableOption(this),
      form: {
        city: [],
        projectName: "",
        leadingIds: [],
        memberIds: [],
        listSoilType: [],
        garbageIds: [],
        weightType: "1",
        // weightTruckTypeIds: [],
        isGo: "1",
        isIn: "0",
        isEntranceWaybill: "0",
        projectAddress: "",
        electronicRange: 500,
        electronicFence: "",
        isInPic: "0",
        isInSoilType: "1",
        ticketEnable: "0",
        isCubicPrice: "0",
        isTicketInventory: "0",
        manualSelectTicket: "0",
        overtimePeriod: 999999,
        truckCodePeriod: 30,
        goInterval: 10,
        smsBalance: 0,
        stopPayBalance: 0,
        isInPictureUploadOffline: "0",
        isGoPictureUploadOffline: "0",
        companyWithdrawPeriod: 24,
        isEntranceHeavyWaybill: "0",
        isGoVehicleType: "0",
        isGoPayDirect: "0",
        maxDirectPay: 1500,
        directTriggerPoint: "1",
        directChannel: "1",
        inWaybillSaveTime: 30, //挖机运单保留时间(分钟):
        goWaybillTipCheck: "0",
      },
      center: [113.98074, 22.55251],
      marker: {
        position: [113.98074, 22.55251],
        visible: true,
        draggable: false,
      },
      mapInfo: {
        lng: 114.061401,
        lat: 22.540293,
        lnglat: [114.061401, 22.540293],
      },
      amapManager,
      events: {
        click: (e) => {
          console.log("jfkdjdfjd");
          this.mapInfo.lng = e.lnglat.lng;
          this.mapInfo.lat = e.lnglat.lat;
          this.mapInfo.lnglat = [e.lnglat.lng, e.lnglat.lat];
          this.form.electronicFence = e.lnglat.lng + "," + e.lnglat.lat;
          //   this.getFormattedAddress();
        },
      },
      markerEvent: {
        dragend: (e) => {
          console.log("dddddd", e);
          let lnglat = e.target.getPosition();
          this.mapInfo.lng = lnglat.lng;
          this.mapInfo.lat = lnglat.lat;
          this.mapInfo.lnglat = [lnglat.lng, lnglat.lat];
          this.form.electronicFence = lnglat.lng + "," + lnglat.lat;
          //   this.getFormattedAddress();
        },
      },
      searchOption: {
        // 限制搜索城市的范围
        citylimit: false,
      },
    };
  },
  components: {
    selectPersonnel,
  },
  computed: {
    ...mapGetters(['tagList']),
    zoom() {
      if (this.form.electronicRange <= 100) {
        return 16;
      }
      if (this.form.electronicRange > 100 && this.form.electronicRange < 700) {
        return 15;
      }
      if (this.form.electronicRange >= 700) {
        return 14;
      }
      return 13;
    },
    projectAddressLabel() {
      if (this.form.projectAddress) {
        return {
          content: this.form.projectAddress,
          textAlign: "center",
        };
      } else {
        return {
          content: "",
          offset: [20, -20],
          textAlign: "center",
        };
      }
    },
  },
  created() {},
  mounted() {
    this.form = this.info;
    getMemberList().then((res) => {
      this.memberList = res.data.data;
    });

    if (this.form.id) {
      // debugger
      this.tmpOvertimePeriod = this.form.overtimePeriod;
      this.$nextTick(() => {
        this.form.city = this.form.gpsCity ? this.form.gpsCity.split(",") : [];
      });
      console.info(this.form.city);
      console.info(this.form);
      if (this.form.overtimePeriod !=999999) {
        this.dynamicValue = this.form.overtimePeriod;
      }
      if (this.form.electronicFence) {
        let arr = this.form.electronicFence.split(",");
        this.mapInfo = {
          lng: arr[0],
          lat: arr[1],
          lnglat: [arr[0], arr[1]],
        };
      } else {
        // this.$message.error("没有找到项目GPS信息");
        this.mapInfo = {
          lng: 114.061401,
          lat: 22.540293,
          lnglat: [114.061401, 22.540293],
        };
        this.form.electronicFence = "114.061401, 22.540293";
      }
      //作业类型
      if (this.form.manHourType) {
        this.dynamicTags = this.form.manHourType.split(",");
        this.tagName = "";
      }
      //作业地点
      if (this.form.inJobAddress) {
        this.inJobAddressTags = this.form.inJobAddress.split(",");
        this.inJobAddressName = "";
      }
      //工时单位
      if (this.form.inUnitWork) {
        this.inUnitWorkTags = this.form.inUnitWork.split(",");
        this.inUnitWorkName = "";
      }
      //班次
      if (this.form.projectShifts) {
        this.projectShiftsTags = this.form.projectShifts;
        this.shiftTimeStart = null;
        this.shiftTimeEnd = null;
        this.shiftName = "";
      }
      if (this.form.smsNoticeMobile) {
        this.mobileForm.smsNoticeMobile = this.form.smsNoticeMobile
          .split(",")
          .map((mobile) => {
            return {
              mobile,
            };
          });
      }
      this.userList = [];
      if (
        this.form.memberNames &&
        this.form.memberIds &&
        this.form.memberIds.length > 0
      ) {
        let memberIds = Array.isArray(this.form.memberIds)
          ? this.form.memberIds
          : this.form.memberIds.split(",");
        let memberNames = this.form.memberNames.split(",");
        this.userList = memberIds.map((item, index) => {
          return {
            id: item,
            deptName: memberNames[index],
          };
        });
      }
      this.beforeMemberIds = this.form.memberIds || [];
    } else {
      // document.title = '项目新增'
      this.form = {
        projectName: "",
        leadingIds: [],
        memberIds: [],
        listSoilType: [],
        garbageIds: [],
        weightType: "1",
        // weightTruckTypeIds: [],
        isGo: "1",
        isIn: "0",
        isEntranceWaybill: "0",
        projectAddress: "",
        electronicRange: 500,
        electronicFence: "",
        isInPic: "0",
        isInSoilType: "1",
        ticketEnable: "0",
        isCubicPrice: "0",
        isTicketInventory: "0",
        manualSelectTicket: "0",
        overtimePeriod: 999999,
        truckCodePeriod: 30,
        goInterval: 10,
        smsBalance: 0,
        stopPayBalance: 0,
        isInPictureUploadOffline: "0",
        isGoPictureUploadOffline: "0",
        companyWithdrawPeriod: 24,
        isEntranceHeavyWaybill: "0",
        isGoVehicleType: "0",
        isGoPayDirect: "0",
        maxDirectPay: 1500,
        directTriggerPoint: "1",
        directChannel: "1",
        inWaybillSaveTime: 30, //挖机运单保留时间(分钟):
        goWaybillTipCheck: "0",
      };

      this.mobileForm = {
        smsNoticeMobile: [
          {
            mobile: "",
          },
        ],
      };
      this.mapInfo = {
        lng: 114.061401,
        lat: 22.540293,
        lnglat: [114.061401, 22.540293],
      };
      this.getCompanyLedgerType();
      this.getInUnitWork();
      this.inJobAddressTags = [];
      this.tagName = "";
      this.inJobAddressName = "";
      this.inUnitWorkName = "";
      this.userList = [];
      this.projectShiftsTags = [
        {
          shiftName: "白班",
          shiftTimeStart: "06:00:00",
          shiftTimeEnd: "18:00:00",
        },
        {
          shiftName: "晚班",
          shiftTimeStart: "18:00:00",
          shiftTimeEnd: "06:00:00",
        },
      ];
      this.shiftTimeStart = null;
      this.shiftTimeEnd = null;
      this.shiftName = "";
    }
    listDictionaryItem({ dictionary: "soil_type" }).then((res) => {
      if (!this.form.id) {
        this.form.listSoilType = res.data.data.map((v) => v.itemName);
      }
      this.soilTypes = res.data.data;
    });
  },
  methods: {
    closeVisible(){
      this.updateVisible = false
       let { tag } = this.findTag(this.$route.path);
          this.$store.commit("DEL_TAG", tag);
          this.$store.commit("DEL_TAG", this.findTag('/chain/project/projectinfo2').tag);
        this.$router
          .push({
            path: "/chain/project/projectinfo2",
            query: { t: Date.now() } 
          })
    },
    checkMax(e){
      let strNum = e.toString().replace(/\D/g, '').slice(0, 6);
      let num = parseInt(strNum, 10);

      if (!isNaN(num)) {
        if (num > 999998) {
           this.form.overtimePeriod = 999998;
        this.dynamicValue=999998
        } else {
          this.form.overtimePeriod = strNum;
        this.dynamicValue=strNum
        }
      } else {
        this.form.overtimePeriod = '';
        this.dynamicValue=''
      }
    },
    checkAllSoil() {
      if (
        this.form.listSoilType.length == this.soilTypes.length &&
        this.form.listSoilType.length > 0
      ) {
        this.form.listSoilType = "";
      } else {
        this.form.listSoilType = this.soilTypes.map((v) => v.itemName);
      }
    },
    changeUserList(value) {
      let arr = JSON.parse(value);
      this.userList = arr;
      this.form.memberIds =
        arr && arr.length > 0 ? arr.map((item) => item.id).join(",") : "";
    },
    preventDefault(item, index) {
      this.userList.splice(index, 1);
    },
    handleElectronicRange(value) {
      const numericValue = value.replace(/[^\d]/g, ""); // 去掉非数字字符
      if (parseInt(numericValue) > 10000) {
        this.form.electronicRange = this.form.electronicRange.slice(0, -1); // 如果大于10000，设为10000
      } else {
        this.form.electronicRange = numericValue;
      }
    },
    submit(row, done) {
      if (this.form.id) {
        this.handleUpdate(row, done);
      } else {
        this.handleSave(row, done);
      }
    },
    getCompanyLedgerType() {
      listDictionaryItem({ dictionary: "company_ledger_type" }).then((res) => {
        this.dynamicTags = res.data.data.map((item) => item.itemName);
      });
    },
    getInUnitWork() {
      listDictionaryItem({ dictionary: "in_unit_work" }).then((res) => {
        this.inUnitWorkTags = res.data.data.map((item) => item.itemName);
      });
    },
    toCheck() {
     
       let { tag } = this.findTag(this.$route.path);
          this.$store.commit("DEL_TAG", tag);
          this.$store.commit("DEL_TAG", this.findTag('/chain/project/projectinfo2').tag);
        this.$router.push({ path: "/chain/business/waybillProcessSettings" });
    },
    updateAfter() {
      // debugger
      if (this.form.overtimePeriod != this.tmpOvertimePeriod) {
        this.tmpOvertimePeriod = this.form.overtimePeriod;
        this.updateOvertimePeriodTitle =
          this.form.overtimePeriod == 999999
            ? "修改运单审核项您勾选了不需要，前往运单审核设置完善审核流程，否则将影响异常运单申请。"
            : `修改运单审核项您勾选了需要(${this.form.overtimePeriod}小时内)，前往运单审核设置完善审核流程，否则将影响异常运单申请。`;
        this.updateVisible = true;
      } else {
        let { tag } = this.findTag(this.$route.path);
          this.$store.commit("DEL_TAG", tag);
          this.$store.commit("DEL_TAG", this.findTag('/chain/project/projectinfo2').tag);
        this.$router
          .push({
            path: "/chain/project/projectinfo2",
            query: { t: Date.now() } 
          })
      }
    },
    addShifts() {
      if (!this.shiftName || !this.shiftTimeStart || !this.shiftTimeEnd) {
        this.$message.error("请输入班次跟时间");
        return false;
      }

      // 验证班次不能重名，中间时间不允许重叠和首尾时间可以
      let isTrue = false;
      this.projectShiftsTags &&
        this.projectShiftsTags.length > 0 &&
        this.projectShiftsTags.forEach((item) => {
          if (item.shiftName == this.shiftName) {
            this.$message.error("班次名称不能重复");
            isTrue = true;
            return false;
          }
          // else if(this.shiftTimeStart>=item.shiftTimeStart&&this.shiftTimeStart<item.shiftTimeEnd){
          //   this.$message.error("班次时间不能重叠")
          //   isTrue = true
          //   return false
          // }else if(this.shiftTimeEnd>item.shiftTimeStart&&this.shiftTimeEnd<=item.shiftTimeEnd){
          //   this.$message.error("班次时间不能重叠")
          //   isTrue = true
          //   return false
          // }else if(this.shiftTimeStart<item.shiftTimeStart&&this.shiftTimeEnd>=item.shiftTimeEnd){
          //   this.$message.error("班次时间不能重叠")
          //   isTrue = true
          //   return false
          // }
        });
      if (isTrue) return false;
      this.projectShiftsTags.push({
        shiftName: this.shiftName,
        shiftTimeStart: this.shiftTimeStart,
        shiftTimeEnd: this.shiftTimeEnd,
      });
    },
    changeBox(val) {
      if (val == 0) {
        this.form.manualSelectTicket = "0";
      }
    },
    addTag(list, name, label) {
      this.tagObj = {
        prop: name,
        tagsProps: list,
        tagName: label,
      };
      this[name] = "";
      this.tagErrTxt = "";
      this.tagVisible = true;
    },
    saveTag() {
      if (!this[this.tagObj.prop]) {
        this.tagErrTxt = "请输入内容后再添加";
        // this.$message.error("请输入内容后再添加");
        return false;
      }
      if (this[this.tagObj.tagsProps].includes(this[this.tagObj.prop])) {
        this.tagErrTxt = `已有相同的${this.tagObj.tagName}`;
        // this.$message.error();
      } else {
        this[this.tagObj.tagsProps].push(this[this.tagObj.prop]);
        this.tagVisible = false;
      }
    },
    changePeriod(newChecked) {
      // 如果用户尝试取消勾选
      if (newChecked == -1) {
        this.form.overtimePeriod = this.previousChecked; // 恢复为之前的选中状态
      } else {
        this.previousChecked = newChecked; // 更新上一次的选中状态
      }
    },
    changeIsEntranceWaybill(val) {},
    handleSave: function (row, done) {
      console.log(row, "row");
      if (
        row.settleType == 4 &&
        row.isGoPayDirect == 1 &&
        row.weightType != 3 &&
        row.isCubicPrice != 1
      ) {
        this.$message.error(
          "出场签单价格为直付价,请选择出口签单的出场数量或出场价格！"
        );
        loading();
        return false;
      }
      if (row.isGoPayDirect != 1) {
        row.maxDirectPay = undefined;
      }
      row.memberIds =
        this.userList && this.userList.length > 0
          ? this.userList.map((item) => item.id).join(",")
          : "";
      row.memberNames =
        this.userList && this.userList.length > 0
          ? this.userList.map((item) => item.deptName).join(",")
          : "";
      row.leadingIds =
        row.leadingIds && row.leadingIds.length > 0
          ? row.leadingIds.join(",")
          : "";
      row.listSoilType =
        row.listSoilType && row.listSoilType.length > 0
          ? row.listSoilType.join(",")
          : "";
      row.garbageIds =
        row.garbageIds && row.garbageIds.length > 0
          ? row.garbageIds.join(",")
          : "";
      row.manHourType =
        this.dynamicTags.length > 0 ? this.dynamicTags.join(",") : "";
      row.inJobAddress =
        this.inJobAddressTags.length > 0 ? this.inJobAddressTags.join(",") : "";
      row.inUnitWork =
        this.inUnitWorkTags.length > 0 ? this.inUnitWorkTags.join(",") : "";
      row.projectShifts = this.projectShiftsTags;

      // row.weightTruckTypeIds =
      //   row.weightTruckTypeIds.length > 0
      //     ? row.weightTruckTypeIds.join(",")
      //     : "";
      // row.weightTruckTypeNames =
      //   row.$weightTruckTypeIds.length > 0
      //     ? row.$weightTruckTypeIds.replace(" | ", ",")
      //     : "";
      row.leadingNames = row.$leadingIds
        ? row.$leadingIds.replace(/\s+\|\s+/g, ",")
        : "";
      row.garbageNames = row.$garbageIds
        ? row.$garbageIds.replace(/\s+\|\s+/g, ",")
        : " ";
      row.projectStatus = 1;
      if (row.settleType == 4) {
        let flag = false;
        this.$refs.mobileForm.validate((valid) => {
          if (!valid) {
            flag = true;
            this.$message.error("请输入APP支付手机号码");
            // return false;
          } else {
            row.smsNoticeMobile = this.mobileForm.smsNoticeMobile
              .map((item) => item.mobile)
              .join();
          }
        });
        if (flag) {
          loading();
          return;
        }
      }
      
      addObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          let { tag } = this.findTag(this.$route.path);
          this.$store.commit("DEL_TAG", tag);
          this.$store.commit("DEL_TAG", this.findTag('/chain/project/projectinfo2').tag);
          this.$router
            .push({
              path: "/chain/project/projectinfo2",
              query: { t: Date.now() } 
            })
          // this.$emit("addAfter", response.data.data);

          done();
          // this.getPage(this.page);
        })
        .catch(() => {
          loading();
        });
    },
    findTag(value) {
      let tag, key;
      this.tagList.map((item, index) => {
        if (item.value.includes(value)) {
          tag = item;
          key = index;
        }
      });
      return { tag: tag, key: key };
    },
    handleUpdate: function (row, done) {
      row.gpsCity = this.form.city.join(",");
      if (this.fleetNameModelTypeCheck.length == 1) {
        row.fleetNameModelType = this.fleetNameModelTypeCheck[0];
      } else if (this.fleetNameModelTypeCheck.length == 2) {
        row.fleetNameModelType = 0;
      }
      if (
        row.settleType == 4 &&
        row.isGoPayDirect == 1 &&
        row.weightType != 3 &&
        row.isCubicPrice != 1
      ) {
        this.$message.error(
          "出场签单价格为直付价,请选择出口签单的出场数量或出场价格！"
        );
        return false;
      }
      if (row.isGoPayDirect != 1) {
        row.maxDirectPay = undefined;
      }
      console.log("row.memberIds", row);
      row.memberIds =
        this.userList && this.userList.length > 0
          ? this.userList.map((item) => item.id).join(",")
          : "";
      row.memberNames =
        this.userList && this.userList.length > 0
          ? this.userList.map((item) => item.deptName).join(",")
          : "";
      row.leadingIds =
        row.leadingIds && row.leadingIds.length > 0
          ? row.leadingIds.join(",")
          : "";
      row.listSoilType =
        row.listSoilType && row.listSoilType.length > 0
          ? row.listSoilType.join(",")
          : "";
      row.garbageIds =
        row.garbageIds && row.garbageIds.length > 0
          ? row.garbageIds.join(",")
          : "";
      row.manHourType =
        this.dynamicTags.length > 0 ? this.dynamicTags.join(",") : "";
      row.inJobAddress =
        this.inJobAddressTags.length > 0 ? this.inJobAddressTags.join(",") : "";
      row.inUnitWork =
        this.inUnitWorkTags.length > 0 ? this.inUnitWorkTags.join(",") : "";
      row.projectShifts = this.projectShiftsTags;

      row.leadingNames = row.$leadingIds
        ? row.$leadingIds.replace(/\s+\|\s+/g, ",")
        : "";
      row.garbageNames = row.$garbageIds
        ? row.$garbageIds.replace(/\s+\|\s+/g, ",")
        : "";
      if (row.settleType == 4) {
        let flag = false;
        this.$refs.mobileForm.validate((valid) => {
          if (!valid) {
            flag = true;
            this.$message.error("请输入APP支付手机号码");
          } else {
            row.smsNoticeMobile = this.mobileForm.smsNoticeMobile
              .map((item) => item.mobile)
              .join();
          }
        });
        if (flag) {
          return;
        }
      }
      //判断新增多少人 减少多少人
      console.log();
      let memberIds = (row.memberIds && row.memberIds.split(",")) || [];
      console.log(memberIds);
      let diff = [];
      if (this.beforeMemberIds && this.beforeMemberIds.length > 0) {
        let set = new Set(memberIds);
        diff = this.beforeMemberIds.filter((v) => !set.has(v));
        console.log("diff", diff);
      }
      let add = [];
      if (memberIds && memberIds.length > 0) {
        let set = new Set(this.beforeMemberIds);
        add = memberIds.filter((v) => !set.has(v));
        console.log("add", add);
      }
      if ((diff && diff.length > 0) || (add && add.length > 0)) {
        this.$confirm(
          `本次修改项目成员新增${add.length}人，减少${diff.length}人`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            putObj(row)
              .then((response) => {
                if (response.data.code == 789) {
                  let _this = this;
                  this.$confirm(response.data.msg, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  })
                    .then(() => {
                      workOffByProjectInfoId({
                        projectInfoId: row.id,
                        staffId: response.data.data,
                      })
                        .then(() => {
                          // _this.$message({
                          //   showClose: true,
                          //   message: "该员工已下班成功，再次点击确认移除该员工",
                          //   type: "success",
                          // });
                          console.log(row);
                          putObj(row)
                            .then((res) => {
                              this.$message({
                                showClose: true,
                                message: "修改成功",
                                type: "success",
                              });
                              this.updateAfter();
                              // this.getPage(this.page);
                              done();
                            })
                            .catch(() => {
                              console.log("err");
                            });
                          // loading();
                        })
                        .catch(() => {
                          console.log("catch");
                        });
                    })
                    .catch(() => {});
                } else {
                  this.$message({
                    showClose: true,
                    message: "修改成功",
                    type: "success",
                  });
                  this.updateAfter();
                  // this.getPage(this.page);
                  done();
                }
              })
              .catch(() => {
                console.log("err");
              });
          })
          .catch((err) => {});
      } else {
        putObj(row)
          .then((response) => {
            if (response.data.code == 789) {
              let _this = this;
              this.$confirm(response.data.msg, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  workOffByProjectInfoId({
                    projectInfoId: row.id,
                    staffId: response.data.data,
                  })
                    .then(() => {
                      // _this.$message({
                      //   showClose: true,
                      //   message: "该员工已下班成功，再次点击确认移除该员工",
                      //   type: "success",
                      // });
                      console.log(row);
                      putObj(row)
                        .then((res) => {
                          this.$message({
                            showClose: true,
                            message: "修改成功",
                            type: "success",
                          });
                          // this.getPage(this.page);
                          this.updateAfter();
                          done();
                        })
                        .catch(() => {
                          console.log("err");
                          // loading();
                        });
                      // loading();
                    })
                    .catch(() => {
                      console.log("catch");
                    });
                })
                .catch(() => {});
            } else {
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
              });
              this.updateAfter();
              // this.getPage(this.page);
              done();
            }
          })
          .catch(() => {
            console.log("err");
          });
      }
    },
    handleClose() {
      this.visible = false;
    },
    submitMap() {
      this.visible = false;
      this.getFormattedAddress();
    },
    onSearchResult(e) {
      if (!e || !e.length || !e[0] || !e[0].location) {
        return;
      }
      console.log("onSearchResult");
      this.form.electronicFence = e[0].location.lng + "," + e[0].location.lat;
      this.mapInfo = {
        lng: e[0].location.lng,
        lat: e[0].location.lat,
        lnglat: [e[0].location.lng, e[0].location.lat],
      };
      this.form.projectAddress = e[0].address;
    },
    /** 打开地图选点弹窗, 选点后可回填到详细地址输入框 */
    openMap() {
      this.visible = true;
    },
    getFormattedAddress() {
      AMap.plugin("AMap.Geocoder", () => {
        let GeocoderOptions = {
          city: "全国",
        };
        let geocoder = new AMap.Geocoder(GeocoderOptions);
        console.log("geocoder", geocoder);
        geocoder.getAddress(this.mapInfo.lnglat, (status, result) => {
          console.log("通过经纬度拿到的地址", result);
          if (status === "complete" && result.info === "OK") {
            this.form.projectAddress = result.regeocode.formattedAddress;
          } else {
            this.mapInfo.address = "无法获取地址";
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.avue-group__header {
  border: none;
  font-weight: 500;
  font-size: 16px;
  color: #313133;
  margin-bottom: 16px;
}

/deep/.avue-group__title {
  border: none;
}

.search-box {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 999;
}

.map-right {
  position: relative;
  width: 100%;
  height: 405px;
}

.map {
  display: flex;

  //   justify-content: space-between;
  .map-label {
    margin-left: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #313133;
    white-space: nowrap;
  }
}

/deep/.el-dialog__footer {
  background: #fff;
  justify-content: flex-end;
  margin-right: 20px;
}

/deep/.el-checkbox {
  width: 108px;

  .el-checkbox__input.is-disabled + span.el-checkbox__label {
    font-weight: 400;
    font-size: 14px;
    color: #313133;
  }

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background: #f5f7fa;
    border-color: #ededf0;
  }
}

.block {
  background: #ededf0;
  padding: 12px 16px;
}

/deep/.custom-radio {
  /* 定制 Radio 样式为 Checkbox */
  .el-radio__input {
    display: none;
    /* 隐藏原始单选按钮 */
  }

  .el-radio__label {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    /* 给复选框预留空间 */
    cursor: pointer;
  }

  .el-radio__label::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 18px;
    height: 18px;
    border: 2px solid #dcdfe6;
    background-color: #fff;
    border-radius: 4px;
    /* 方形复选框，可以改成 50% 为圆形 */
  }

  .is-checked .el-radio__label::before {
    border-color: #409eff;
    /* 选中状态 */
    background-color: #409eff;
  }

  .is-checked .el-radio__label::after {
    content: "";
    position: absolute;
    left: 6px;
    top: 6px;
    width: 6px;
    height: 6px;
    background-color: #fff;
    border-radius: 50%;
  }
}

/deep/.tip-desc {
  font-weight: 400;
  font-size: 14px;
  color: #939399;
}

/* 详细地址与地图按钮同一行: 输入框 + 地图图标 */
.project-address-with-map {
  display: flex;
  align-items: center;
  gap: 8px;
}
.project-address-with-map .address-input-manual {
  flex: 1;
}
.project-address-with-map .address-input-manual /deep/ .el-input__inner {
  cursor: text;
}
.map-icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  flex-shrink: 0;
}
.map-icon-after-address {
  margin-left: 0;
}
/deep/.el-input-group__append {
  background: #fff;
  border-left: none;
}
.custom-input {
  /deep/.el-input__inner {
    border-right: none;
  }
}
/deep/.add-tag {
  background: #fff !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  color: #35b1ff !important;
  height: 24px;
  line-height: 0;
  &:hover {
    font-weight: 400 !important;
    font-size: 12px !important;
    color: #35b1ff !important;
  }
}

.dialog-content {
  margin-left: 30px;
  .err-tip {
    margin-top: 4px;
    font-weight: 400;
    font-size: 14px;
    color: #e60026;
  }
  /deep/.el-input--medium .el-input__inner {
    height: 48px;
    line-height: 48px;
  }
}
.custom-time {
  border-radius: 3px;
  border: 1px solid #ededf0;
  margin-right: 12px;
  /deep/.el-input__inner {
    border: none;
  }
}

.shift-tag-list {
  // margin-left: 123px;
  flex-wrap: wrap;
  .shift-tag {
    display: flex;
    align-items: center;
    width: 496px;
    height: 24px;
    background: #ffffff;
    border-radius: 3px;
    border: 1px solid #ededf0;
    margin-top: 16px;
    height: 24px;
    margin-right: 12px;
    .left {
      padding: 0 15px;
      width: 140px;
      margin-right: 8px;
    }
    .right {
      width: 358px;
      padding: 0 15px;
    }
  }
}
/deep/.el-dialog__footer {
  background: #fff;
}

.check-title1 {
  margin-top: 8px;
  display: flex;
  // align-items: center;
  font-weight: 500;
  font-size: 16px;
  color: #313133;
  padding-bottom: 6px;
  border-bottom: 1px solid #ededf0;
}
.desc {
  margin-left: 30px;
  margin-top: -30px;
  font-weight: 400;
  font-size: 14px;
  color: #626266;
  margin-bottom: 16px;
}
.dialog-footer {
  padding-right: 20px;
}
/deep/.el-form-item__label {
  //line-height: 30px !important;
  width: 150px!important;
}
/deep/.el-form-item__content{
   margin-left: 150px!important;
}
// /deep/.custom-label {
//   .el-form-item__label {
//     line-height: 17px !important;
//   }
// }
.check-all {
  position: absolute;
  right: -40px;
  top: 0;
}
</style>